module.exports = __webpack_public_path__ + "img/revisore_smartform.0ef819b0.png";